import PropTypes from 'prop-types';
import React from 'react';

import Tabs from 'components/Tabs';
import { small } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const CustomCollectionSecondaryNavigation = ({
  tabs,
  activeTabIndex,
  linkUrls,
  trackNavigation,
}) => {
  return (
    <div className="CustomCollectionSecondaryNavigation">
      <div className="CustomCollectionSecondaryNavigation__tabs-affix">
        <Tabs
          tabs={tabs}
          activeTabIndex={activeTabIndex}
          linkUrls={linkUrls}
          enableScrollTo={false}
          onTabClick={trackNavigation}
        />
      </div>
      <style jsx>
        {`
          .CustomCollectionSecondaryNavigation__tabs-affix {
            border-bottom: 2px solid ${Theme.get('colors-black-20')};
          }

          @media ${small} {
            .CustomCollectionSecondaryNavigation__tabs-affix {
              box-shadow: 0px -2px ${Theme.get('colors-black-20')} inset;
              border-bottom: hidden;
            }
          }
        `}
      </style>
    </div>
  );
};

CustomCollectionSecondaryNavigation.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  linkUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  trackNavigation: PropTypes.func,
};

CustomCollectionSecondaryNavigation.defaultProps = {
  trackNavigation: () => {},
};

export default CustomCollectionSecondaryNavigation;
